<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="this.page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="广告图片" slot="storeImg" align="center">
        <template slot-scope="{ row }">
          <img :src="row.adImg" style="width: 70px;height:70px" alt="" @click="seeSampleImage(row)" />
        </template>
      </el-table-column>
      <el-table-column label="上架/下架" slot="operationSex" align="center">
        <template slot-scope="{ row }">
          <el-switch inactive-color="#bebebe" @change="handleSwitch(row, 'switch')" v-model="row.isEnable"></el-switch>
        </template>
      </el-table-column>

      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row, 'edit')">编辑</el-button>
          <el-button size="mini" type="danger" round @click="handleBtn(row, 'del')">删除</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 二维码弹窗 -->

    <el-dialog title="添加报价设置" :visible.sync="DialogCode" :close-on-click-modal="false" width="500px"
      @closed="DialogCode = false">
      <div class="qustion-top widQus" style="margin-top:0">
        <div><img src="@/assets/images/imgAll/ico_ts_red@2x.png" alt /></div>
        <div>扫码小程序进入报价设置页面，添加/修改报价设置</div>
      </div>
      <div class="img_code">
        <img src="@/assets/images/imgAll/ico_ts_red@2x.png" alt />
      </div>
      <div style="float:right;margin-bottom:10px">
        <el-button @click="DialogCode = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--弹框-->
    <el-dialog title="提示" :visible.sync="dialogQuotatVisible" :close-on-click-modal="false" width="380px"
      @closed="handleDialogClosed">
      <span class="dialog-tip"></span>
      <div style="
          font-size: 16px;
          color: #666666;
          line-height: 30px;
        ">
       {{ dialogTip }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="handleSuccess">确定</el-button>
        <el-button @click.native="handleClose">取消</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="
      () => {
        showViewer = false;
      }
    " :url-list="imgList" />
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { http } from "../../../utils/request/newIndex"
import _api from "@/utils/request";
export default {
  name: "Table",
  mixins: [MinXinRequest],
  components: { ElImageViewer },
  data() {
    return {
      // 店员弹窗
      formInline: {
        staffName: '',
        staffMobile: '',
      },
      dialogTip:"",
      storeId: '',
      actionType: "",
      staffVisible: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      DialogDataList: [],
      DialogTableColumns: [
        { label: '店员姓名', prop: 'staffName' },
        { slotName: 'staffType' },
        { label: '联系电话', prop: 'staffMobile' },
      ],
      //////////列表
      seachDataList: [],
      //弹窗
      dialogVisible: false, // 弹框的出现与否
      ////////
      tableColumns: [
        { label: "广告名称", prop: "adName" },
        { slotName: "storeImg" },
        { label: "创建时间", prop: "createTime" },
        { label: "最后修改时间", prop: "updateTime" },
        { slotName: "operationSex" },
        { slotName: "operation" }
      ],
      // 添加编辑门店弹窗
      editId: '',
      storeDiaTitle: '',
      ruleForm: {
        storeName: '',
        storeCode: '',
        storeAddress: '',
      },
      rules: {
        storeName: [
          { required: true, message: '请输入门店名称', trigger: 'change' }
        ],
        storeAddress: [
          { required: true, message: '请输入门店地址', trigger: 'change' }
        ],
      },
      dialogTitle: '',
      showViewer: false,
      imgList: [],
      dialogStoreVisible: false,
      //////////////报价设置弹窗
      dialogQuotatVisible: false,
      quoteList: [],//报价弹窗数组
      DialogCode: false,
      Switchparams:{}
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
    storeAddEdit() {
      return this.$store.state.tagsView.storeAddEdit
    },
    storeExcel() {
      return this.$store.state.tagsView.storeExcel
    },
  },
  created() {
    this.handleCurrentChange(1);
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal)
      this.handleCurrentChange()
    },
    storeAddEdit(newVal) {
      if (newVal === 'add') {
        this.storeDiaTitle = '添加'
        this.dialogStoreVisible = true
        this.ruleForm.storeAddress = ''
        this.ruleForm.storeCode = ''
        this.ruleForm.storeName = ''
      } else {
        this.storeDiaTitle = '编辑'
      }
    },
    storeExcel(newVal) {
      console.log(newVal, 'storeExcel')
      if (newVal == 'storeExcel') {
        this.handleCurrentChange(1);
      }
    },
    dialogStoreVisible(newVal) {
      if (newVal === false) {
        this.$store.commit('tagsView/STORE_ADDEDIT', 'edit')
      }
    }
  },
  methods: {
    handleDialogClosed() {
      this.dialogQuotatVisible = false;
      this.handleCurrentChange();
    },
    // //弹窗取消
    handleClose() {
      this.dialogQuotatVisible = false;
    },
    //弹窗确定
    handleSuccess() {
      if (this.actionType == 'del') {
        http.deleteAdverts({ id: this.storeId }).then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.dialogQuotatVisible = false;
          }
        });
      } else {
        http.upOrDownAdverts(this.Switchparams).then(res => {
          console.log(res)
          if (res.code == 1) {
            this.$message.success(res.msg)
            this.dialogQuotatVisible = false
          } else {
            this.$message.error(res.msg)
          }
          this.handleCurrentChange()
        })
      }
    },
    // 查看示例图大图
    seeSampleImage(row) {
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(row.adImg);
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(val)
      // const baseRequest = {
      //   storeManager: this.SeachParams.storeManager,
      //   storeManagerPhone: this.SeachParams.staffMobile,
      //   storeName: this.SeachParams.storeName,
      //   pageNum: val ? val : this.SeachParams.pageNum,
      //   pageSize: 10,
      // };
      const baseRequest = {
        "adName": this.SeachParams.adName,
        "adType": "01",
        "endTime": this.SeachParams.endTime,
        "pageNum": val ? val : this.SeachParams.pageNum,
        "pageSize": 10,
        "startTime": this.SeachParams.startTime
      }
      http.companyAdverts(baseRequest).then(res => {
        if (res.code === 1) {
          console.log(res)
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.$store.commit("tagsView/POST_STAFF", this.seachDataList);
          this.$store.commit('tagsView/STORE_EXCEL', 'false')
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 表格按钮操作
    handleBtn(row, type) {
      console.log("表格操作", type, row);
      if (type == 'edit') {
        this.$router.push({
          path: "/OnlinreyService/addAds",
          query: { type: "edit", id: row.id },
        });
      } else if (type == 'del') {
        this.dialogTip="确认要删除此广告？"
        this.actionType="del"
        this.storeId = row.id
        this.dialogQuotatVisible = true
      }
    },
    //启用/禁用账号
    handleSwitch(row) {
      this.actionType=""
      this.dialogTip=" 确认要执行该操作吗？"
      this.Switchparams = {
        id: row.id,
        status: row.isEnable,
      }
      this.dialogQuotatVisible = true
      console.log(this.Switchparams);
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  /deep/ .form_input .el-input__inner {
    height: 30px !important;
  }

  .dialog-tip {
    font-size: 12px;
    color: #FF687B;
  }

  .widQus {
    width: 96%;
    margin: 15px auto;
  }

  .qustion-top {
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 15px;

    img {
      width: 18px;
      object-fit: contain;
      margin-right: 5px;
    }

    div {
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      color: #FF687B;
      line-height: 0px;
    }
  }

  .box-qustion {
    // min-height: 276px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
    background: #F5F5F5;
    border-radius: 4px;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qustion-item {
    padding-bottom: 10px;

    .el_input_item {
      width: 100px !important;
    }

    /deep/ .el-input__inner {
      height: 35px !important;
    }

    .left {
      margin: 20px 50px 0 10px;
    }

    .right {
      margin: 20px 10px 0 0;
    }

    .text {
      margin-right: 5px;
    }
  }

  .img_code {
    width: 200px;
    height: 200px;
    margin: 20px auto;

    img {
      width: 100%;
      object-fit: contain;
    }
  }


  /*修改滚动条样式*/
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 6px;
    width: 8px;
    background: white;
  }

  ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    width: 5px;
    background-color: #0981FF;
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: #0981FF;
    -webkit-border-radius: 6px;
    -webkit-border-radius: 6px;
  }

  .none-Data {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 22px;
    color: #666;
  }
}
</style>
